import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ProductView } from "@/components/ProductView";
import { useBasket } from "@/lib/BasketContext";
import { api } from "@/lib/api";

export default function ProductDetails() {
  const { slug } = useParams();
  const { add } = useBasket();
  const [product, setProduct] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setProduct(null);
    setNotFound(false);
    api
      .get(`/public/products/${slug}`)
      .then((res) => setProduct(res.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  const onAdd = (variant, qty, unitPrice) => {
    add({
      product_id: product.id,
      variant_id: variant?.variant_id || null,
      name: product.name,
      option_values: variant?.option_values || {},
      unit_price_pence: unitPrice,
      qty,
      image: product.images?.[0]?.url_400 || product.images?.[0]?.url || null,
      slug: product.slug,
    });
    toast.success(`${product.name} added to your basket`);
  };

  if (notFound) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-24 text-center" data-testid="product-not-found">
        <h1 className="font-serif text-3xl font-bold text-cream-text">This bake isn't available</h1>
        <p className="mt-3 text-sm text-cream-muted">It may have sold out or been retired for the season.</p>
        <Link to="/shop" className="mt-6 inline-block rounded-full bg-gold px-7 py-3 text-sm font-bold text-choco hover:bg-gold-hover" data-testid="back-to-shop-link">
          Back to Shop
        </Link>
      </div>
    );
  }

  if (!product) {
    return <div className="mx-auto max-w-7xl px-4 py-24 text-sm text-cream-muted" data-testid="product-loading">Loading…</div>;
  }

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8" data-testid="product-page">
      <Link to="/shop" className="text-sm font-bold text-gold hover:underline" data-testid="product-back-link">
        ← All bakes
      </Link>
      <div className="mt-6">
        <ProductView product={product} onAdd={onAdd} />
      </div>
    </div>
  );
}
